import React from "react";
import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";
import HighchartsReact from "highcharts-react-official";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { useSelector } from "react-redux";
import Loader from "../Loader";

// if (typeof Highcharts === "object") {
//   Highcharts3D(Highcharts);
// }

const ProfitChart = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const { data: profitChart = [], isLoading: profitChartIsLoading } =
    useGetProtectedApiDataQuery({
      url: "profit_chart",
      lang: languageType,
    });

  const filterDataYearWise = (year) => {
    return profitChart
      ?.filter((item) => item.field_profit_in_years === year)
      ?.map((item) => parseInt(item.field_profit_field_value));
  };

  const profit22 = filterDataYearWise("2022-23") || [];
  const profit23 = filterDataYearWise("2023-24") || [];
  const profit24 = filterDataYearWise("2024-25") || [];

  const options = {
    chart: {
      type: "column",
      height: 400,
      marginTop: 30,
      options3d: {
        enabled: true,
        alpha: 35,
        beta: 0,
        depth: 75,
        viewDistance: 125,
      },
    },
    title: {
      text: getText("Profits", "लाभ"),
      align: "center",
    },
    xAxis: {
      categories: [
        getText("Sales(Cr)", "बिक्री(करोड़)"),
        getText("Profit before Tax(Cr)", "कर देने से पूर्व लाभ(Crs)"),
        getText("Dividend before Tax(Cr)", "लाभांश दिया(Crs)"),
      ],
    },
    yAxis: {
      min: 0,
      tickInterval: 200,
      title: {
        text: getText("Generation (MU)", "उत्पादन(एमयू)"),
      },
    },

    tooltip: {
      formatter: function () {
        return `
           <div class="custom-tooltip">
              <span class="tooltip-series"><b>${
                this.series.name
              }</b></span><br/>
              <b>${this.key}</b> : ${this.y.toLocaleString()} Crs.
           </div>
    `;
      },
      useHTML: true,
      shared: false, // This is the key change
    },
    plotOptions: {
      column: {
        grouping: true,
        shadow: false,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "2024-2025",
        data: profit24 || null,
        color: "#79933c",
      },
      {
        name: "2023-2024",
        data: profit23,
        color: "#be514e",
      },
      {
        name: "2022-2023",
        data: profit22,
        color: "#ff9900",
      },
    ],
  };

  if (profitChartIsLoading) {
    return <Loader />;
  }
  return (
    <>
      <div className="cursor-none">
        <details className="visually-hidden">
          <summary>Profit Chart Data Summary</summary>
          <p>
            This chart shows financial performance across four fiscal years:
          </p>
          <ul>
            <li>
              X-axis shows three metrics: Sales, Profit before Tax, and Dividend
              before Tax
            </li>
            <li>Y-axis shows values in Crores with intervals of 200</li>
            <li>
              Each year is represented by a different colored column group
            </li>
            <li>Key data points:</li>
          </ul>
        </details>
        <div className="performance-generation-sec h-100 wow zoomIn pt-2">
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
        <div id="chart-description" className="visually-hidden">
          <p>Interactive 3D column chart displaying:</p>
          <ul>
            <li>Blue columns represent 2015-2016 data</li>
            <li>Red columns represent 2016-2017 data</li>
            <li>Green columns represent 2017-2018 data</li>
            <li>Dark green columns represent 2018-2019 data</li>
            {/* <li>Hover over columns to see exact values</li> */}
            <ul>
              {[
                { name: "2024-2025", data: profit24 },
                { name: "2023-2024", data: profit23 },
                { name: "2022-2023", data: profit22 },
              ].map((year, index) => (
                <li key={index}>
                  In {year.name}: Sales: {year.data[2] || 0} Cr, Profit before
                  Tax: {year.data[1] || 0} Cr, Dividend before Tax:{" "}
                  {year.data[0] || 0} Cr.
                </li>
              ))}
            </ul>
          </ul>
        </div>
      </div>
    </>
  );
};

export default ProfitChart;
